module.exports = __webpack_public_path__ + "static/media/cremaschi-agustin.c1385e8e.jpg";